import styled from "styled-components";

import _FormControlLabel from "@material-ui/core/FormControlLabel";
import _Grid from "@material-ui/core/Grid";

export const FormControlLabel = styled(_FormControlLabel)``;
export const GridCustom = styled(_Grid)`
  text-align: center;
  ${FormControlLabel} {
    margin: 0;
  }
`;
